var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unfiltered-layout"},[_c('UnfilteredHeader'),_c('router-view'),_c('UnfilteredFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }